import useAppContext from "./hooks/useAppHook";
import React, {useEffect} from "react";
import {Navigate, useLocation} from "react-router-dom";
import {useLazyQuery} from '@apollo/client';
import {login, loginVariables} from "./graphql/ql/operation-result-types";
import {LOGIN} from "./graphql/ql/schema";
import {callAxiosServiceWithParam} from "./services/callAxios";
import { setAuthToken } from "./App";
import { safeGetItem, safeSetItem, safeRemoveItem } from "./utils/safeStorage";

const RequireAuth = ({children}) => {
    const {user, setUser, token, setToken} = useAppContext();
    const {pathname, search} = useLocation();
    const [executeLogin, {
        called,
        loading,
        data,
        error
    }] = useLazyQuery<login, loginVariables>(LOGIN, {fetchPolicy: "network-only"});
    useEffect(() => {
        if (data && data.login?.token && !loading) {
            safeSetItem("token", data.login?.token);
            safeSetItem("userName", data.login.user?.login?.userName ? data.login.user?.login?.userName : "");
            let url = data.login?.user?.customer?.id + "/profile/" + data.login?.user?.id;
            callAxiosServiceWithParam("users/signedurl", "filepath=" + encodeURIComponent(url)).then((filePath => {
                if (data.login?.user) {
                    const updatedUser = {
                        ...data.login.user,
                        photoUrl: filePath.data
                    };
                    setUser(updatedUser);
                }
            })).catch((e) => {
                console.log(e);
            });
            if (data && data.login?.token) {
                if (!token && token !== data.login.token) { // add a check to prevent recursive calls
                  setToken(data.login.token);
                }
            }
        }
    }, [data, token,loading]);

    if (loading) return <>Authenticating</>;
    let url: any = `${pathname}${search}`;
    if (pathname && pathname === "/") {
        url = null;
    }
    if (error) {
        safeSetItem("token", "");
        safeSetItem("userName", "");
        safeRemoveItem("restrictedToken");
        // Use window.location.href for authentication errors to ensure proper hash routing
        const redirectUrl = url ? `/#/login?redirect=${encodeURIComponent(url)}` : '/#/login';
        window.location.href = redirectUrl;
        return null;
    }
    let auth = token || safeGetItem("token");
    if (auth && (!user || !user.id)) {
        if (!loading && (!user || !user.id)) { //&& children.props.name !== "Home") {
            if (!called) {
                setAuthToken(auth);
                executeLogin({variables: {"userName": "", "password": ""}})
            }
        }
        if (data && data.login?.token) {
            if (!safeGetItem("token")) {
                const redirectUrl = url ? `/#/login?redirect=${encodeURIComponent(url)}` : '/#/login';
                window.location.href = redirectUrl;
                return null;
            }
            return children;
        } else if (!loading && called) {
            if ((!data || ((data && !data.login?.token)))) {
                const redirectUrl = url ? `/#/login?redirect=${encodeURIComponent(url)}` : '/#/login';
                window.location.href = redirectUrl;
                return null;
            }
            return children;
        }
    } else {
        if (!user || !user.id) {
            const redirectUrl = url ? `/#/login?redirect=${encodeURIComponent(url)}` : '/#/login';
            window.location.href = redirectUrl;
            return null;
        } else {
            return children;
        }
    }
    return <></>;
};

export default RequireAuth
